/// if any links have parameterized tokens, try to substitute those tokens from the OrderViewModel

$("a[href*='{restaurantid}']").each(function () {
    var currentHref = $(this).attr('href');
    if (orderViewModel.store.id)
    {
        $(this).attr('href', currentHref.replace("{restaurantid}", orderViewModel.store.id));
    }
    //  if the store is still not available, change the href to the locator.
    else {
        $(this).attr('href', subwayScript.navigation.getLocatorUrl());
    }
});